<div class="flex-row">
  @if (inputQtdeVisivel()) {
    <div class="item-1">
      <button [disabled]="!statusComponent || isQuantidadeMinima(quantidadeItemString)" (click)="removerQtdeDoItemAtual(this.getMultiplo())" class="campoMenos" color="primary" mat-icon-button name="btnRemoveItem">
        <mat-icon class="lixeira">{{"remove"}}</mat-icon>
      </button>
    </div>
  }
  @if (inputQtdeVisivel()) {
    <div class="item-2 mat-input">
      <mat-form-field class="mat-form mat-input" name="qtdeItem">
        <div class="mat-form-field-label">
          <mat-label class="mat-label">
            Quantidade ({{ unMedVenda }})
            @if ((item.itemPedido.quantidade > item.itemPedido.quantidadeEstoque) || item.itemDetalhes.outrosPrecos.length === 0) {
              <img src="assets/images/warning.png" style="height: 16px;" (click)="onClickQuantidade()">
            }
          </mat-label>
          <input autocomplete="off" [disabled]="!statusComponent" #inputHtml class="mat-input" matInput appDelayedInput
          (keydown.enter)="this.validarQuantidadeInformada(quantidadeItemString)" (blur)="onBlur(quantidadeItemString)"
          (delayedInput)="atualizarQtdeDoItemAtual(quantidadeItemString)" [delayTime]="delayTime" [(ngModel)]="quantidadeItemString"
          ignorarRotina="false" id="qtde" name="qtde" step="multiplo" min="multiplo" (focusin)="setQuantidadeAtualDoItem($event)"
          (keypress)="barrarInputsIncorretos($event)"/>
        </div>
      </mat-form-field>
    </div>
  }
  @if (botaoAdicionarItemVisivel()) {
    <div class="item-3">
      <button [disabled]="!statusComponent || this.isQuantidadeMaxima(quantidadeItemString)" (click)="addQuantidadeItem(this.getMultiplo())" color="primary" mat-icon-button name="btnAdicionaItem">
        <mat-icon class="mais">add</mat-icon>
      </button>
    </div>
  }
</div>
@if (botaoAdicionarVisivel()) {
  <div class="flex-row">
    @if (!itemDisponivel() && apresentaEstoqueOutrasFiliais && this.item.itemDetalhes.estoqueOutrasFiliais.length > 0) {
      <mat-label class="texto-botao">Disponível em outra filial</mat-label>
    }
    <button (click)="adicionarAoCarrinho()"
      [disabled]="!statusComponent || !itemDisponivel() && (!apresentaEstoqueOutrasFiliais || this.item.itemDetalhes.estoqueOutrasFiliais.length === 0)"
      class="item-4" color="primary" mat-raised-button name="btnAdicionar">
      {{ !itemDisponivel() ? ( apresentaEstoqueOutrasFiliais && this.item.itemDetalhes.estoqueOutrasFiliais.length > 0 ? "Consultar disponibilidade" : "Indisponível") : "Adicionar" }}
    </button>
  </div>
}
@if (!emPreview) {
  <div class="flex-row">
    <button color="primary" mat-raised-button class="item-4" (click)="removerItemDoCarrinho()" name="btnRemoverItem">
      Remover
    </button>
  </div>
}
